module.exports = __webpack_public_path__ + "img/gb-nir.43b61fea.svg";